import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const evaeldConfig: TSPConfig = {
  key: 'evaeld',
  name: 'EVA ELD',
  imageName: 'EVAELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API Key from EVA ELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default evaeldConfig;
